import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CombinedStore } from 'src/app/core/combined.store';
import { Product } from '../constants/product.constants';
import { SharedDataService } from '../services/shared-data.service';

@Injectable({
  providedIn: 'root',
})
export class StepActivationGuard implements CanActivate {
  store = inject(CombinedStore);
  constructor(private sharedDataService: SharedDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url.split('/')[2];
    const subscription = this.sharedDataService.getSubscription();
    let groupStep = 0;

    let indexReprise = 1;

    if (this.store.context().referenceContrat || (this.store.context().avenants?.length ?? 0) > 0) {
      groupStep = 1;
      indexReprise = 6;
    } else if (this.store.context().referenceDevis) indexReprise = 24;

    if (
      this.store.context().produit === Product.HN &&
      !this.store.context().referenceContrat &&
      !this.store.context().referenceDevis
    ) {
      indexReprise = 0; // Page eligbilité
    }

    if (subscription) {
      const index = subscription()?.findStepIndexesByUrl(currentUrl!);
      this.sharedDataService.setGroupStep(index?.groupIndex ?? groupStep);
      this.sharedDataService.setStepIndex(index?.stepIndex ?? indexReprise);
    }

    return true;
  }
}
